module.exports = __webpack_public_path__ + "static/media/testAmountSuccess.62723f4f.png";